export const routeLabels: Record<string, string> = {
  "/dashboard/page": "فرم",

  // edit profile labels
  "/dashboard/edit-profile": "ویرایش پروفایل",
  "/dashboard/edit-profile/research": "اطلاعات پژوهشی",
  "/dashboard/edit-profile/education": "اطلاعات تحصیلی و آموزشی",
  "/dashboard/edit-profile/social-links": "وبسایت‌ و شبکه‌های اجتماعی",

  // form creator
  "/dashboard/form": "فرم ها",
  "/dashboard/form/entities": "جداول",
  "/dashboard/form/:id/preview": "پیش نمایش فرم",
  "/dashboard/workflow-form": "پیش نمایش فرم",

  // role
  "/dashboard/role": "نقش ها",

  // category
  "/dashboard/category": "دسته بندی ها",

  // notification
  "/dashboard/notification": "اعلان های سیستم",

  // role
  "/dashboard/menu": "منو",

  // change password
  "/dashboard/change-password": "تغییر رمز عبور",

  // workflow
  "/dashboard/workflow": "گردش کار",

  //newbook
  "/dashboard/new-book": "ثبت کتاب جدید",

  // article
  "/dashboard/new-article": "ثبت مقاله جدید",
  "/dashboard/new-article/url": "لینک",
  "/dashboard/new-article/scholar": "Scholar",

  //error
  "/dashboard/error": "خطای سیستم"
};
